@import "../../common/base";

@include button-reset();
@include box-sizing();
@include typography-reset();

:host {
  display: grid;
  grid-template-rows: 1fr max-content;
}

:host(.ch-chat--additional-content) {
  grid-template-rows: 1fr max-content max-content;
}

.assistant-content,
.user-content {
  // Improve rendering performance by not rendering off-screen messages
  contain: paint;
}

.message-with-images {
  display: grid;
}

img {
  display: block;
  // Necessary to avoid overflowing the cell width when the window does not
  // have enough width
  max-inline-size: 100%;
}

.assistant-loading {
  display: grid;
  grid-template-columns: max-content 1fr;
  align-items: center;
}

.assistant-files {
  grid-area: 2 / 2;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.file-skeleton {
  position: relative;

  &::before,
  &::after {
    content: "";
    display: inline-flex;
  }
}

// - - - - - - - - - - - - - - - -
//         Send container
// - - - - - - - - - - - - - - - -
.stop-generating-answer-button {
  grid-area: input-wrapper;
  position: absolute;
  inset-block-start: 0;
  justify-self: center;
  transform: translateY(-100%);
}

.images-to-upload {
  display: flex;
  flex-wrap: wrap;
}

.send-container {
  display: grid;
  grid-template: "input-wrapper send-or-audio" 1fr / 1fr max-content;
  position: relative;
  align-items: end;

  &--file-uploading {
    grid-template: "upload-image input-wrapper send-or-audio" 1fr / max-content 1fr max-content;
  }
}

.send-input-wrapper {
  grid-area: input-wrapper;
}

.send-or-audio-button {
  grid-area: send-or-audio;
}

.spinner-loading {
  animation: infinite-rotate 0.875s linear 0s infinite;
}

// This is a WA due to shadow DOM limitations/scoping with keyframes
@keyframes infinite-rotate {
  100% {
    transform: rotate(1turn);
  }
}

@keyframes gx-skeleton-load {
  to {
    transform: translateX(192%);
  }
}

.processing-animation {
  content: "";
  margin-inline-start: auto;
  display: block;
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="6" height="6" viewBox="0 0 6 6"><path d="M3 6C4.65685 6 6 4.65685 6 3C6 1.34315 4.65685 0 3 0C1.34315 0 0 1.34315 0 3C0 4.65685 1.34315 6 3 6Z" fill="%23939498"/></svg>'),
    url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="6" height="6" viewBox="0 0 6 6"><path d="M3 6C4.65685 6 6 4.65685 6 3C6 1.34315 4.65685 0 3 0C1.34315 0 0 1.34315 0 3C0 4.65685 1.34315 6 3 6Z" fill="%23939498"/></svg>'),
    url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="6" height="6" viewBox="0 0 6 6"><path d="M3 6C4.65685 6 6 4.65685 6 3C6 1.34315 4.65685 0 3 0C1.34315 0 0 1.34315 0 3C0 4.65685 1.34315 6 3 6Z" fill="%23939498"/></svg>');
  inline-size: 20px;
  block-size: 16px;
  background-position: left, center, right;
  background-size: 4px, 4px, 4px;
  background-repeat: no-repeat;
  animation: ellipsis 1s infinite linear;
}

// This is a WA to have an animation
@keyframes ellipsis {
  0% {
    background-size: 6px, 4px, 4px;
  }
  25% {
    background-size: 4px, 6px, 4px;
  }
  50% {
    background-size: 4px, 4px, 6px;
  }
  75% {
    background-size: 4px, 6px, 4px;
  }
  100% {
    background-size: 6px, 4px, 4px;
  }
}
